import React from 'react';
import { RoleChip } from '../common/Badge';

export function Topbar({ profile, onLogout }) {
  const roleLabel = profile.role === 'trainer'
    ? 'Trainer'
    : profile.role === 'employer'
    ? 'Employer'
    : profile.role === 'supervisor'
    ? 'Supervisor'
    : `Year ${profile.year || '?'} Apprentice`;

  return (
    <div className="topbar">
      <div className="brand">Signed<em>Off</em></div>
      <div className="brand-short">Signed<em>Off</em></div>
      <div className="topbar-right">
        <span className={`role-chip${profile.role === 'trainer' ? ' tr' : ''}`}>{roleLabel}</span>
        <span style={{ color: 'var(--text)', fontSize: 13 }}>{profile.name}</span>
        <button className="btn-sm" onClick={onLogout}>Sign Out</button>
      </div>
    </div>
  );
}
